import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { PenTool } from "lucide-react";
import { SignaturePad } from "@/components/shared/SignaturePad";
import { toast } from "sonner";

/**
 * Signature Section for Rental Agreement
 */
export const SignatureSection = ({ 
  signatureInfo, 
  setSignatureInfo, 
  renterName, 
  isEditing 
}) => {
  return (
    <Card className="print:border print:shadow-none" data-testid="signature-section">
      <CardHeader className="pb-4">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <PenTool className="w-4 h-4 text-primary" />
          SIGNATURES & ACKNOWLEDGMENT
        </CardTitle>
        <CardDescription>
          By signing below, I acknowledge that I have read and agree to all terms and conditions of this rental agreement.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Renter Signature */}
          <div className="space-y-3">
            <SignaturePad
              label="RENTER - SIGN HERE"
              initialSignature={signatureInfo.renterSignature}
              disabled={!isEditing}
              onSave={(signature) => {
                setSignatureInfo({
                  ...signatureInfo,
                  renterSignature: signature,
                  renterSignedAt: new Date().toISOString()
                });
                toast.success("Signature captured", {
                  description: "Renter signature has been saved."
                });
              }}
              onClear={() => {
                setSignatureInfo({
                  ...signatureInfo,
                  renterSignature: "",
                  renterSignedAt: ""
                });
              }}
            />
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>Renter: {renterName || '_______________'}</span>
              <span>
                {signatureInfo.renterSignedAt 
                  ? `Signed: ${new Date(signatureInfo.renterSignedAt).toLocaleDateString()}`
                  : 'Date: _______________'
                }
              </span>
            </div>
          </div>

          {/* Company Representative Signature */}
          <div className="space-y-3">
            <SignaturePad
              label="AGENT - SIGN HERE"
              initialSignature={signatureInfo.agentSignature}
              disabled={!isEditing}
              onSave={(signature) => {
                setSignatureInfo({
                  ...signatureInfo,
                  agentSignature: signature,
                  agentSignedAt: new Date().toISOString()
                });
                toast.success("Signature captured", {
                  description: "Agent signature has been saved."
                });
              }}
              onClear={() => {
                setSignatureInfo({
                  ...signatureInfo,
                  agentSignature: "",
                  agentSignedAt: ""
                });
              }}
            />
            <div className="space-y-1">
              <div className="flex justify-between text-xs text-muted-foreground">
                <span>Ak Car Rental Representative</span>
                <span>
                  {signatureInfo.agentSignedAt 
                    ? `Signed: ${new Date(signatureInfo.agentSignedAt).toLocaleDateString()}`
                    : 'Date: _______________'
                  }
                </span>
              </div>
              {isEditing && (
                <Input
                  value={signatureInfo.agentName || ''}
                  onChange={(e) => setSignatureInfo({...signatureInfo, agentName: e.target.value})}
                  placeholder="Agent name"
                  className="h-8 text-sm"
                />
              )}
              {!isEditing && signatureInfo.agentName && (
                <p className="text-xs text-muted-foreground">Agent: {signatureInfo.agentName}</p>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SignatureSection;
